import { UseQueryResult } from '@tanstack/react-query'
import { Card, CardBody } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { Intervento } from '../../types'
import { getLabelTipoBilancia, getLabelTipoBilanciaEm } from '../../utils/utils'

interface InterventoBilanciaInfoInterface {
  bilancia_data?: Intervento['bilancia_data']
  pk_cliente?: Intervento['pk_cliente']
  nome_cliente?: Intervento['nome_cliente']
  note?: Intervento['note']
}

type CardBilanciaInfoProps = {
  intervento: UseQueryResult<InterventoBilanciaInfoInterface, Error>
}

export default function CardBilanciaInfo({ intervento }: CardBilanciaInfoProps) {
  return (
    <Card className="mt-3">
      <CardBody>
        <div className="label-m">Dati bilancia</div>
        <div className="mt-2 p-md d-flex align-items-center">
          <span className="material-icons me-2" style={{ fontSize: '16px' }}>
            scale
          </span>
          <Link to={`/bilance/${intervento?.data?.bilancia_data?.id}`}>
            <span className="me-2 link-md text-body-secondary">
              Bilancia {intervento?.data?.bilancia_data?.matricola}{' '}
              {intervento.data?.bilancia_data?.sigla ? `(${intervento.data?.bilancia_data?.sigla})` : ''}
            </span>
          </Link>
          <span className="me-2">-</span>
          <span className="me-2">{getLabelTipoBilancia(intervento?.data?.bilancia_data?.tipo_bilancia)}</span>
          <span className="me-2">-</span>
          <span className="me-2">{getLabelTipoBilanciaEm(intervento?.data?.bilancia_data?.tipo_bilancia_em)}</span>
        </div>
        <div className="mt-4">
          <div className="label-m">Dati cliente</div>
          <div className="mt-2 p-md d-flex align-items-center">
            <span className="material-icons me-2" style={{ fontSize: '16px' }}>
              person
            </span>
            <Link to={`/clienti/${intervento?.data?.pk_cliente}`}>
              <span className="me-2 link-md text-body-secondary">{intervento?.data?.nome_cliente}</span>
            </Link>
          </div>
          <div className="mt-2 p-md d-flex align-items-center">
            {intervento?.data?.bilancia_data?.sede_data?.toponimo_data?.nome}{' '}
            {intervento.data?.bilancia_data?.sede_data?.via},{' '}
            {intervento.data?.bilancia_data?.sede_data?.civico
              ? intervento.data?.bilancia_data?.sede_data?.civico + ', '
              : ''}
            {intervento.data?.bilancia_data?.sede_data?.comune_data?.cap}{' '}
            {intervento.data?.bilancia_data?.sede_data?.comune_data?.nome} (
            {intervento.data?.bilancia_data?.sede_data?.provincia_data?.sigla})
          </div>
        </div>
        <div className="mt-4">
          <div className="label-m">Note</div>
          <div className="mt-2 p-md">{intervento?.data?.note || 'Nessuna nota'}</div>
        </div>
      </CardBody>
    </Card>
  )
}
